{
  "header": {
    "name": "Name"
  },
  "empty": "No sectors found",
  "button": {
    "new": "New sector",
    "newSub": "Add a sub sector",
    "update": "Update the sector",
    "remove": "Remove the sector"
  },
  "label": "sector",
  "validation": {
    "required": "Field is required",
    "maxLength": "Max length: {maxLength}",
    "nameFormat": "The name must contains the following characters [a-zA-Z0-9 _.-]",
    "minLength": "Min length: {minLength}"
  },
  "details": {
    "tab": {
      "device": {
        "label": "S4 local station"
      },
      "application": {
        "label": "Applications"
      },
      "user": {
        "label": "Users"
      },
      "userGroup": {
        "label": "User groups"
      },
      "dtwins": {
        "label": "Devices"
      },
      "sectors": {
        "label": "Sectors"
      }
    },
    "buttons": {
      "create": "New sector",
      "createSubSector": "Add sub sector",
      "remove": "Remove the sector",
      "attach": {
        "application": "Attach an application",
        "device": "Attach a device",
        "user": "Attach a user",
        "userGroup": "Attach a user group",
        "dtwins": "Attach a device"
      },
      "detach": "Detach from sector",
      "details": "Details"
    },
    "currentSelection": "Current selection"
  },
  "modals": {
    "create": {
      "title": "Create a new sector",
      "sector": {
        "label": "Sector's name",
        "description": "Description"
      }
    },
    "update": {
      "title": "Update an existing sector",
      "sector": {
        "label": "Sector's name",
        "description": "Description"
      }
    },
    "remove": {
      "title": "Remove sector {sectorName}",
      "description": "Are you sure that you want to remove this sector?",
      "notAllowed": "The deletion of a sector is not possible, some devices are attached to it",
      "titleAlt": "Delete the sector"
    },
    "confirmDetach": {
      "device": {
        "title": "Device detach from sector",
        "description": "The device \"{name}\" will be detached from sector \"{sectorLabel}\" | The following devices will be detached from sector \"{sectorLabel}\"",
        "warning": "The detached device from sector won't be visible anymore from management screen (according user's rights). | The detached devices from sector won't be visible anymore from management screen (according user's rights)."
      },
      "application": {
        "title": "Application detach from sector",
        "description": "The application \"{name}\" will be detached from sector \"{sectorLabel}\" | The following applications will be detached from sector \"{sectorLabel}\"",
        "warning": "The detached application from sector won't be visible anymore from management screen (according user's rights). | The detached applications from sector won't be visible anymore from management screen (according user's rights)."
      },
      "user": {
        "title": "User detach from sector",
        "description": "The user \"{name}\" will be detached from sector \"{sectorLabel}\" | The following users will be detached from sector \"{sectorLabel}\"",
        "warning": "The detached users from sector won't have access anymore to visualization and applications and devices management. | The detached user from sector won't have access anymore to visualization and applications and devices management."
      },
      "userGroup": {
        "title": "User group detach from sector",
        "description": "The user group \"{name}\" will be detached from sector \"{sectorLabel}\" | The following user groups will be detached from sector \"{sectorLabel}\"",
        "warning": "The detached users groups from sector won't have access anymore to visualization and applications and devices management. | The detached users group from sector won't have access anymore to visualization and applications and devices management."
      },
      "errors": {
        "list_empty": "You must select at least one item to detach"
      },
      "dtwins": {
        "title": "Device detach from sector",
        "description": "The device \"{name}\" will be detached from sector \"{sectorLabel}\" | The following devices will be detached from sector \"{sectorLabel}\"",
        "warning": "The detached device from sector won't be visible anymore from management screen (according user's rights). | The detached devices from sector won't be visible anymore from management screen (according user's rights)."
      }
    },
    "attach": {
      "device": {
        "title": "Attach devices to sector",
        "description": "Check the devices to be attached to the sector"
      },
      "application": {
        "title": "Attach applications to sector",
        "description": "Check the applications to be attached to the sector"
      },
      "user": {
        "title": "Attach users to sector",
        "description": "Check the users to be attached to the sector"
      },
      "userGroup": {
        "title": "Attach user groups to sector",
        "description": "Check the user groups to be attached to the sector"
      },
      "errors": {
        "list_empty": "You must select at least one item to attach"
      },
      "dtwins": {
        "description": "Check the devices to be attached to the sector",
        "title": "Attach devices to sector"
      }
    },
    "view": {
      "title": "View a sector"
    }
  },
  "search": "Search by name",
  "select": {
    "all": "Select all sectors",
    "selected": "sectors selected"
  },
  "treeview": {
    "actionsButton": {
      "title": "Actions"
    }
  },
  "selectedUsers": "No users selected | {count} user selected | {count} selected users",
  "selectedUserGroups": "No groups selected | {count} group selected | {count} selected groups"
}
